import axios from 'axios';
import { TTP_API_URL } from 'Config';

export const getAppsStatus = (token = null) => {
  const requestUrl = `${TTP_API_URL}/organization/organization-settings/apps-status`;
  
  return axios.get(requestUrl, {
    params: { access_token: token }
  });
};



// WEBPACK FOOTER //
// ./app/api/TamtamAPI/apps.js